module.exports = __webpack_public_path__ + "static/media/Water.7c2c0d36.svg";